/**
 * Media banner "sticky pin" effect: when a media-banner section has
 * data-sticky-effect="true" and is immediately followed by another
 * section carrying the "sticky-section" class (see the "class" key in
 * media-banner.liquid's schema), the banner stays pinned in place while
 * the next section scrolls up over it, then unpins once that next
 * section reaches the top of the viewport.
 *
 * Vanilla JS rewrite -- the original was jQuery-based (jQuery is never
 * loaded in this theme, so it crashed immediately with "$ is not
 * defined") and also used `block.closest("section")`, which returned
 * null because Shopify wraps section content in
 * `<div class="shopify-section" id="shopify-section-...">`, not a
 * `<section>` tag -- that null was then passed to `.getAttribute("id")`,
 * throwing "Cannot read properties of null" on every page load
 * regardless of whether any banner even used the sticky effect.
 */
(function () {
  function mediaBanner() {
    document.querySelectorAll('.media-banner').forEach(function (block) {
      if (block.dataset.stickyEffect !== 'true') return;

      var box = block.closest('.shopify-section');
      if (!box) return;

      var id = box.getAttribute('id');
      if (!id) return;

      var normalElement = document.querySelector('#' + id + ' + .sticky-section');
      if (!normalElement) return;

      var isSticky = false;
      window.addEventListener('scroll', function () {
        var stickyTop = box.getBoundingClientRect().top;
        var normalElementTop = normalElement.getBoundingClientRect().top;

        if (stickyTop <= 0 && !isSticky) {
          box.classList.add('sticky-active');
          isSticky = true;
        }
        if (normalElementTop <= 0 && isSticky) {
          box.classList.remove('sticky-active');
          isSticky = false;
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    mediaBanner();
    document.addEventListener('shopify:section:load', mediaBanner);
  });
})();
